<script>
import icons from '@/schemas/icons';
import { mapGetters } from 'vuex';
import { INLINES } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

export default {
  name: 'AppNote',

  props: {
    content: {
      type: Object,
      required: true,
    },

    type: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      icons,

      options: {
        renderNode: {
          [INLINES.ENTRY_HYPERLINK]: (node) => `<a href="${this.getLink(node.data.target)}">
            ${node.content[0].value}
          </a>`,
        },
      },
    };
  },

  computed: {
    ...mapGetters('menu', ['getPageLink']),

    icon() {
      // eslint-disable-next-line
      return require(`@/assets/svg-icons/${icons[this.content.icon]}.svg`);
    },

    text() {
      return documentToHtmlString(this.content.text, this.options);
    },
  },

  methods: {
    getLink(link) {
      return link ? this.getPageLink(link) : '';
    },
  },
};
</script>

<template>
  <div class="note" :class="[type, { warning: content.icon === 'Warning' }]">
    <span class="note-icon">
      <img class="icon" :src="icon" />
    </span>

    <div class="text" v-html="text" />
  </div>
</template>

<style lang="scss" scoped>
.note {
  background: $background-color-secondary;
  border-radius: $border-radius-xx-small;
  padding: $space-16;
  display: flex;
  align-items: center;
  max-width: $text-block-width;

  .note-icon {
    margin-right: $space-16;
    flex-shrink: 0;
    display: block;
  }

  .icon {
    display: block;
    width: 24px;
    height: 24px;
  }

  &.large {
    max-width: 100%;
  }

  &.checklist {
    padding: $space-8 0;
  }

  &.warning {
    background-color: $tint-color-yellow-soft;

    .svg-icon {
      color: $tint-color-yellow;
    }
  }

  :deep(.text) {
    p {
      @include caption-regular;
      margin: 0;
    }
    a {
      @include caption-bold;
      margin: 0;
    }
  }
}

@media print {
  .note {
    break-inside: avoid;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
}
</style>
